import api from './api';

export async function submitContactRequest(payload) {
    const { data } = await api.post('/contact', payload);
    return data;
}
